import React from 'react';
import Truncate from 'react-truncate';
import { Link } from 'react-router-dom';
import ArticleModal from '../article-modal';
import { HERO, SUB_HERO, MINIMAL_HERO, READ_MORE_SETTING } from '../../app-constants';
import { ReadMoreContext } from './readMoreContext';

const ReadMoreText = (props) => {
  const { contentText, articleId, linkUrl, layoutMode } = props;
  const { linkText, heroLineLimit, subHeroLineLimit, normalLineLimit, minHeroLineLimit } = READ_MORE_SETTING;
  let lines;
  switch (layoutMode) {
    case HERO:
      lines = heroLineLimit;
      break;
    case SUB_HERO:
      lines = subHeroLineLimit;
      break;
    case MINIMAL_HERO:
      lines = minHeroLineLimit;
      break;
    default:
      lines = normalLineLimit;
  }

  return (
    <React.Fragment>
      <Truncate lines={lines} ellipsis="..." className="text-truncate">
        {contentText}
      </Truncate>
      <ReadMoreContext.Consumer>
        {({ modal }) => (
          modal
            ? <ArticleModal linkText={linkText} articleId={articleId} />
            : <div className="read-more button clear left-aligned"><Link to={linkUrl}>{linkText}</Link></div>
        )
        }
      </ReadMoreContext.Consumer>
    </React.Fragment>
  );
};

export default ReadMoreText;
